import React, { useEffect } from 'react';
import FormFieldWrapper from '@plone/volto/components/manage/Widgets/FormFieldWrapper';
import {
  customSelectStyles,
  selectTheme,
} from '@plone/volto/components/manage/Widgets/SelectStyling';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { getCategories } from '../../../actions';

const messages = defineMessages({
  SelectLevel1: {
    id: 'Select Level 1',
    defaultMessage: 'Select level 1',
  },
  SelectLevel2: {
    id: 'Select Level 2',
    defaultMessage: 'Select level 2',
  },
  SelectLevel3: {
    id: 'Select Level 3',
    defaultMessage: 'Select level 3',
  },
  NoOptions: {
    id: 'No options',
    defaultMessage: 'No options',
  },
});

const CategoryWidget = (props) => {
  const { value, onChange, reactSelect } = props;

  const intl = useIntl();
  const dispatch = useDispatch();

  const categories = useSelector((state) => state.categories);

  useEffect(() => {
    if (categories.firstLoad) {
      dispatch(getCategories());
    }
  }, [categories.firstLoad, dispatch]);

  let cat1 = null,
    cat2 = null,
    cat3 = null;

  if (value?.categoriaSuperior?.categoriaSuperior) {
    cat1 = {
      label: value.categoriaSuperior.categoriaSuperior.nomeCategoria,
      value: value.categoriaSuperior.categoriaSuperior.id,
    };
    cat2 = {
      label: value.categoriaSuperior.nomeCategoria,
      value: value.categoriaSuperior.id,
    };
    cat3 = {
      label: value.nomeCategoria,
      value: value.id,
    };
  } else if (value?.categoriaSuperior) {
    cat1 = {
      label: value.categoriaSuperior.nomeCategoria,
      value: value.categoriaSuperior.id,
    };
    cat2 = {
      label: value.nomeCategoria,
      value: value.id,
    };
  } else if (value) {
    cat1 = {
      label: value.nomeCategoria,
      value: value.id,
    };
  }

  if (categories.loading) {
    return <div>Aguarde, carregando...</div>;
  }

  if (categories.error) {
    return <div>{categories.error}</div>;
  }

  if (!categories.loaded) {
    return (
      <FormFieldWrapper {...props}>
        <div>Categorias não carregadas.</div>
        <button onClick={() => dispatch(getCategories())}>
          Tente novamente
        </button>
      </FormFieldWrapper>
    );
  }

  const sortCategories = (arr) =>
    arr.sort((a, b) =>
      a.label.localeCompare(b.label, 'pt', { sensitivity: 'base' }),
    );

  const Select = reactSelect.default;

  const level1 = sortCategories(
    categories.data
      ?.filter((cat) => !cat.categoriaSuperior && cat.statusCategoria === 'P')
      .map((cat) => ({
        label: cat.nomeCategoria,
        value: cat.id,
      })) || [],
  );

  const level2 = sortCategories(
    categories.data
      ?.filter(
        (cat) =>
          cat.categoriaSuperior?.id === cat1?.value &&
          cat.statusCategoria === 'P',
      )
      .map((cat) => ({
        label: cat.nomeCategoria,
        value: cat.id,
      })) || [],
  );

  const level3 = sortCategories(
    categories.data
      ?.filter(
        (cat) =>
          cat.categoriaSuperior?.id === cat2?.value &&
          cat.statusCategoria === 'P',
      )
      .map((cat) => ({
        label: cat.nomeCategoria,
        value: cat.id,
      })) || [],
  );

  const handleCategoryChange = (selectedCat, level) => {
    let newCat = null;
    if (selectedCat) {
      newCat = categories.data.find((cat) => cat.id === selectedCat.value);
    } else {
      // Quando a opção selecionada é removida selectedCat é null
      if (level === 3) {
        // Quando remove do nível 3, nível 2 precisa ser removido
        newCat = value.categoriaSuperior;
      } else if (level === 2) {
        if (value?.categoriaSuperior?.categoriaSuperior) {
          // Quando remove do nível 2 e nível 3 está selecionado
          newCat = value.categoriaSuperior.categoriaSuperior;
        } else {
          // Quando remove do nível 2 e nível 3 não está selecionado
          newCat = value.categoriaSuperior;
        }
      }
    }
    onChange(props.id, newCat);
  };

  return (
    <>
      <FormFieldWrapper {...props}>
        <Select
          className="react-select-container"
          classNamePrefix="react-select"
          styles={customSelectStyles}
          theme={selectTheme}
          options={level1}
          value={cat1}
          isClearable
          placeholder={intl.formatMessage(messages.SelectLevel1)}
          noOptionsMessage={() => intl.formatMessage(messages.NoOptions)}
          onChange={(selectedValue) => {
            handleCategoryChange(selectedValue, 1);
          }}
        ></Select>
        {cat1 ? (
          <Select
            className="react-select-container"
            classNamePrefix="react-select"
            styles={customSelectStyles}
            theme={selectTheme}
            options={level2}
            value={cat2}
            isClearable
            placeholder={intl.formatMessage(messages.SelectLevel2)}
            noOptionsMessage={() => intl.formatMessage(messages.NoOptions)}
            onChange={(selectedValue) => {
              handleCategoryChange(selectedValue, 2);
            }}
          ></Select>
        ) : null}
        {cat2 ? (
          <Select
            className="react-select-container"
            classNamePrefix="react-select"
            styles={customSelectStyles}
            theme={selectTheme}
            options={level3}
            value={cat3}
            isClearable
            placeholder={intl.formatMessage(messages.SelectLevel3)}
            noOptionsMessage={() => intl.formatMessage(messages.NoOptions)}
            onChange={(selectedValue) => {
              handleCategoryChange(selectedValue, 3);
            }}
          ></Select>
        ) : null}
      </FormFieldWrapper>
    </>
  );
};

export default injectLazyLibs(['reactSelect'])(CategoryWidget);
